/* Packages */
import React, { useEffect, useState } from "react";
import { useRecoilState } from "recoil";

/* Styles */
import "./styles.scss";

/* Components */
import CheckBox from "../../widgets/CheckBox";
import Collapsible from "../Collapsible";
import { serviceListState, selectedServiceListState } from "../../atoms/signUpAtom";
import i18next from "i18next";
import axios from "../../utils/axios";

const saveLocalStorage = (elemKey, val) => {
  let formData = {};
  if (localStorage.getItem("formData")) {
    formData = JSON.parse(localStorage.getItem("formData"));
  }
  formData[elemKey] = val;
  localStorage.setItem("formData", JSON.stringify(formData));
};

const ServicesOfferedSelection = (props) => {
  const [serviceList, setServiceList] = useRecoilState(serviceListState);
  const [selectedServiceList, setSelectedServiceList] = useRecoilState(selectedServiceListState);

  useEffect(() => {
    axios.get(`/api/client/services/`, {
      headers: {
        "Accept-Language" : i18next.language
      },
    })
        .then((response) => {
          setServiceList(response.data.services);
        })
        .catch((err) => {
          console.log("errors: ", err);
        });

  }, [i18next.language]);

  const groupObjectByKey = serviceList.reduce((acc, service) => {
    const { category, category_title, id, service_type, title } = service;
    acc[category_title] = [...(acc[category_title] || []), { category_title, category, id, service_type, title }];

    return acc;
  }, {});

  // TODO: data not saving in the local storage!

  // const newObject = Object.entries(groupObjectByKey).filter(([key, value], id) => key !== "undefined");

  // const arrayRemove = (arr, value) => {
  //   return arr.filter(function (ele) {
  //     return ele !== value;
  //   });
  // };

  const handleCheckBoxChange = (e) => {
    if (e.target.dataset.checked !== "true") {
      setSelectedServiceList([...selectedServiceList, e.target.value]);
      setSelectedServiceList([...selectedServiceList, Number(e.target.value)]);

      // saveLocalStorage("selectedServiceList", [...selectedServiceList, e.target.value]);
    } else {
      setSelectedServiceList([...selectedServiceList.filter((ele) => ele !== e.target.value)]);
    }
  };
  useEffect(() => {
    /* Getting selected items from local storage*/
    if (JSON.parse(localStorage.getItem("formData"))) {
      const localDataObj = JSON.parse(localStorage.getItem("formData"));
      if (localDataObj.selectedServiceList) {
        setSelectedServiceList(localDataObj.selectedServiceList);
      }
    }
  }, []);

  return (
    <div className={"services-offered-selection"}>
      <div className="section-title-and-error">
        <h2 className={"title-name"}>{props.sectionName} </h2>
        <p className={"error"}>{props.error !== "undefined" && props.error}</p>
      </div>

      <div className={"services-offered-section"}>
        {Object.entries(groupObjectByKey).map(([key, value], id) => {
          return (
            <Collapsible key={id} label={key}>
              <div className={"section"}>
                <div className={"input-group"}>
                  {value.map((element, key) => {
                    return (
                      <label key={key} htmlFor={`services-${element.id}`} className={"parent"}>
                        <CheckBox
                          service_type={element.service_type}
                          category_title={element.category_title}
                          category={element.category}
                          onChange={handleCheckBoxChange}
                          name={element.title}
                          value={element.id}
                          id={`services-${element.id}`}
                        />
                        <div className={"label-title"}>{element.title}</div>
                      </label>
                    );
                  })}
                </div>
              </div>
            </Collapsible>
          );
        })}
      </div>
    </div>
  );
};

export default ServicesOfferedSelection;
